
import React from 'react';
import { Route } from 'react-router-dom';
import useInactivityTimer from '../hooks/useInactivityTimer.jsx';

// This component handles the inactivity timer for all routes except the home page
const InactivityHandler = () => {
  return (
    <Route path="/:path">
      <InactivityTimerForRoutes />
    </Route>
  );
};

// This separate component ensures the hook is only used when a route is matched
const InactivityTimerForRoutes = () => {
  const { countdown } = useInactivityTimer();
  return <>{countdown}</>;
};

export default InactivityHandler;
